
const generateBasicChartData = (currentCount: number, factor: number = 0.7) => {
  if (currentCount === 0) {
    return Array(7).fill(0);
  }

  const startValue = 0;  // Always start from 0
  const step = (currentCount - startValue) / 6;  // Divide the remaining range into 6 steps
  
  return [
    startValue,
    Math.max(0, Math.round(startValue + step)),
    Math.max(0, Math.round(startValue + step * 2)),
    Math.max(0, Math.round(startValue + step * 3)),
    Math.max(0, Math.round(startValue + step * 4)),
    Math.max(0, Math.round(startValue + step * 5)),
    currentCount
  ];
};

export const generateClientChartData = (clientCount: number) => {
  return generateBasicChartData(clientCount, 0.85);
};

export const generateProgramChartData = (programCount: number) => {
  return generateBasicChartData(programCount, 0.7);
};

export const generateNewClientsChartData = (count: number) => {
  if (count === 0) return Array(7).fill(0);
  if (count === 1) return [0, 0, 0, 0, 0, 0, 1];
  
  const step = count / 6;  // Divide the total range into 6 steps
  return [
    0,  // Always start from 0
    Math.round(step),
    Math.round(step * 2),
    Math.round(step * 3),
    Math.round(step * 4),
    Math.round(step * 5),
    count
  ];
};

export const generateRemovedClientsChartData = generateNewClientsChartData;

